import React, { useEffect, useRef, useState } from "react";
import { useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { Form } from "reactstrap";
import { useLocation, Redirect } from "react-router-dom";
import { toast } from "react-hot-toast";
import L from "leaflet";
import PerfectScrollbar from "react-perfect-scrollbar";
import {
  GEOJSON_STYLES,
  SIG_TIPE_BASED_BIDANG,
  TIPE_PETA,
  ucFirst,
  uppercaseFirstLetter,
} from "~/utils";
import MapsCore from "~/components/MapsCore";
import DynamicLayer from "~/components/DynamicLayer";
import LayoutPeta from "~/layouts/peta";
import TabPeta from "~/layouts/peta/TabsPeta";
import EditStyle from "~/components/EditStyle";
import PropertiesForm from "~/components/PropertiesForm";
import PetaWithLayerBidang from "./peta-with-layer-bidang";
import request from "~/utils/request";

const DynamicPeta = () => {
  const mapRef = useRef(null);
  const layerRef = useRef([]);

  const [activeLayer, setActiveLayer] = useState(null);
  const [openStyleEditor, setOpenStyleEditor] = useState(false);
  const [, setLoadingEditLayer] = useState(false);

  const [sigURL, setSigURL] = useState([]);

  const { search } = useLocation();
  const { desa } = useSelector((state) => state.Auth);
  const { urlFilter, showPetaJalan } = useSelector((state) => state.Map);
  const { register, control, setValue, handleSubmit } = useForm();

  const getTipeNameQuery = new URLSearchParams(search).get("tipe");
  const isLayerWithBidang = new URLSearchParams(search).get(
    "layer-with-bidang"
  );

  const title = `Peta ${ucFirst(getTipeNameQuery)} - Desa ${ucFirst(
    desa?.nama_desa
  )}`;

  // const url = `/v1/sig?filter{tipe.nama}=${getTipeNameQuery}`;

  const handleEditLayer = (values) => {
    const filterActiveLayerInStyle = Object.fromEntries(
      Object.entries(activeLayer.properties.properties).filter(([key]) =>
        GEOJSON_STYLES.includes(key)
      )
    );

    const payload = {
      properties: {
        ...values,
        ...filterActiveLayerInStyle,
      },
    };

    const sigID = activeLayer?.properties?.id;

    setLoadingEditLayer(true);

    request
      .patch(`/v1/sig/${sigID}/`, payload)
      .then(() => {
        toast.success(
          `Layer ${uppercaseFirstLetter(
            activeLayer?.properties?.properties?.nama
          )} berhasil diupdate !`
        );
      })
      .finally(() => setLoadingEditLayer(false));
  };

  const handleFeatureClick = (feature, layer) => {
    window.layer = layer;

    const getCurrentZoom = mapRef.current.leafletElement.getZoom();

    const isZoom = getCurrentZoom >= 15 ? getCurrentZoom : 15;

    if (layer?.feature?.geometry?.type === "Point") {
      mapRef.current.leafletElement.flyTo(
        new L.LatLng(layer?._latlng.lat, layer?._latlng.lng),
        isZoom
      );
      layer.bindTooltip(layer.feature.properties.properties.nama).openTooltip();
    } else {
      const centroid = layer.getBounds().getCenter();
      mapRef.current.leafletElement.flyTo(
        new L.LatLng(centroid.lat, centroid.lng),
        isZoom
      );
      layerRef.current.leafletElement.resetStyle();
      setTimeout(() => {
        layer.setStyle({
          color: "red",
          weight: 7,
          opacity: 0.8,
          fillOpacity: 0.8,
        });
      }, 1);
    }

    setActiveLayer(feature);
  };

  const handleEditStyleLayers = () => {
    setOpenStyleEditor(!openStyleEditor);
  };

  const sortPropertiesActiveLayer =
    activeLayer &&
    Object.fromEntries(
      Object.entries(activeLayer?.properties?.properties).sort()
    );

  useEffect(() => {
    if (!SIG_TIPE_BASED_BIDANG.includes(getTipeNameQuery)) {
      setSigURL((prevSigURL) => [
        ...prevSigURL,
        `/v1/sig?filter{tipe.nama}=${getTipeNameQuery}`,
      ]);
    }
  }, [getTipeNameQuery]);

  useEffect(() => {
    if (urlFilter) {
      setSigURL((prevSigURL) => [urlFilter]);
    }
  }, [urlFilter]);

  useEffect(() => {
    if (showPetaJalan) {
      setSigURL((prevSigURL) => [
        ...prevSigURL,
        `/v1/sig/stream/?filter{tipe.nama}=${showPetaJalan}`,
      ]);
    }
  }, [showPetaJalan]);

  if (isLayerWithBidang === "true") {
    return <PetaWithLayerBidang />;
  }

  if (getTipeNameQuery === TIPE_PETA.BIDANG) {
    return <Redirect to="/peta-bidang" />;
  }

  return (
    <LayoutPeta title={title}>
      <LayoutPeta.LeftSidebar isOpen={false}>
        <TabPeta
          isBasedBidang={SIG_TIPE_BASED_BIDANG.includes(getTipeNameQuery)}
        >
          <Form onSgeoJSONDataubmit={handleSubmit(handleEditLayer)}>
            <div style={{ height: "100vh" }}>
              <div className="pl-2 pr-2 pt-2">
                {sortPropertiesActiveLayer ? (
                  <>
                    <h4 className="text-dark">Info Layer</h4>
                    <hr />
                    <div
                      className="pb-5 mb-5"
                      style={{ height: "calc(100vh - 100px)" }}
                    >
                      <PerfectScrollbar>
                        <PropertiesForm
                          control={control}
                          register={register}
                          setValue={setValue}
                          properties={sortPropertiesActiveLayer}
                        />
                      </PerfectScrollbar>
                    </div>
                  </>
                ) : (
                  <div>
                    <i className="mdi mdi-information-outline mr-1" /> Silakan
                    pilih layer untuk melihat info.
                  </div>
                )}
              </div>
              {/* {sortPropertiesActiveLayer && (
                <FormGroup
                  style={{
                    position: "absolute",
                    top: "100%",
                    width: "100%",
                    marginTop: "8px",
                  }}
                >
                  <Button
                    block
                    size="lg"
                    type="submit"
                    color="primary"
                    disabled={loadingEditLayer}
                    style={{ borderRadius: "0px" }}
                  >
                    {loadingEditLayer ? "mengedit layer..." : "Simpan"}
                  </Button>
                </FormGroup>
              )} */}
            </div>
          </Form>

          <hr />
        </TabPeta>
      </LayoutPeta.LeftSidebar>

      <LayoutPeta.RightSidebar isOpen={openStyleEditor}>
        <EditStyle layers={layerRef?.current} activeLayer={activeLayer} />
      </LayoutPeta.RightSidebar>

      <MapsCore
        ref={mapRef}
        dynamicDownloadMaps
        handleEditStyleLayers={handleEditStyleLayers}
        download={!SIG_TIPE_BASED_BIDANG.includes(getTipeNameQuery)}
        editStyleLayers={!SIG_TIPE_BASED_BIDANG.includes(getTipeNameQuery)}
      >
        {sigURL?.map((elemURL) => (
          <DynamicLayer
            filter
            url={elemURL}
            ref={layerRef}
            mapRef={mapRef}
            onFeatureClick={handleFeatureClick}
            bidang={SIG_TIPE_BASED_BIDANG.includes(getTipeNameQuery)}
          />
        ))}
      </MapsCore>
    </LayoutPeta>
  );
};

export default DynamicPeta;
